import React from 'react';
import styled from 'styled-components';

import { OfferImagePositionEnum, OfferPaymentImage } from 'features/offers/types';
import { useOffers } from 'features/offers';

export const TopLayout = styled('img')`
  width: 100%;
  height: auto;
  display: block;

  ${(props: any) => {
    return `
      ${
        props['data-withmobile'] === true
          ? `
            display: none;

            ${props.theme.mediaQueries.desktop} {
              display: block;
            }
          `
          : ''
      }
    `;
  }};
`;

export const MobileTopLayout = styled('img')`
  width: 100%;
  height: auto;

  ${({ theme: { mediaQueries } }) => {
    return `
        display: block;
  
        ${mediaQueries.desktop} {
          display: none;
        }
      `;
  }}
`;

const Top = () => {
  const {
    buyInformation: { offerImages },
  } = useOffers();

  const images = offerImages
    .filter((image) =>
      [OfferImagePositionEnum.Top, OfferImagePositionEnum.MobileTop].includes(image.position)
    )
    .reduce((prev, image) => {
      return { ...prev, [image.position]: image };
    }, {} as Record<OfferImagePositionEnum, OfferPaymentImage>);

  const topImage = images[OfferImagePositionEnum.Top];
  const mobileTopImage = images[OfferImagePositionEnum.MobileTop];

  return (
    <>
      {!!topImage && <TopLayout data-withmobile={!!mobileTopImage} src={topImage.imageUrl} />}
      {!!mobileTopImage && <MobileTopLayout src={mobileTopImage.imageUrl} />}
    </>
  );
};

export default Top;
